import React from 'react';
import styled from 'styled-components';

const B2Style = styled.svg``;

export const B2 = ({ color }) => {
	return (
		<B2Style
			xmlns='http://www.w3.org/2000/svg'
			width='22.262'
			height='18.954'
			viewBox='0 0 22.262 18.954'
		>
			<path
				id='Pet'
				d='M769.185,432.692h9.7l4.43-4.427a.856.856,0,0,1,1.458.6v2.583l1.367.577a.859.859,0,0,1,.492.562h0l.231.821,1.847.629a.855.855,0,0,1,.577.81h.006v2.426a.856.856,0,0,1-.79.85l-5.262.864v5.817a2.157,2.157,0,0,1-4.314,0v-2.774h-4.868v2.774a2.149,2.149,0,0,1-.626,1.525,2.18,2.18,0,0,1-1.531.636,2.176,2.176,0,0,1-2.164-2.161v-7.8h-.558A2.03,2.03,0,0,1,767.2,435.7a2.228,2.228,0,0,1,0-1.7,2.031,2.031,0,0,1,1.982-1.309Zm1.421,1.713h-1.421a.411.411,0,0,0-.4.231.571.571,0,0,0-.036.215.578.578,0,0,0,.036.214.414.414,0,0,0,.4.234h1.421a.853.853,0,0,1,.851.853v8.655a.459.459,0,0,0,.133.316.45.45,0,0,0,.316.131.444.444,0,0,0,.315-.131.43.43,0,0,0,.135-.316v-3.631a.854.854,0,0,1,.85-.856h6.576a.86.86,0,0,1,.863.856v3.631a.454.454,0,0,0,.127.316.434.434,0,0,0,.311.131.417.417,0,0,0,.315-.131.434.434,0,0,0,.133-.316v-6.291l-2.747-4.111Zm12.456-3.469h0l-2.722,2.722,2.455,3.673,4.789-.78v-1.088l-1.7-.577v0a.863.863,0,0,1-.546-.583l-.23-.859-1.441-.608a.857.857,0,0,1-.6-.817v-1.079Z'
				transform='translate(-767.034 -428.014)'
				fill={color}
			/>
		</B2Style>
	);
};
